import { recordHistory } from '@/db/history';
import { requestAccountDataAutoSync } from '@/features/account/accountDataAutoSync';

/**
 * Tiny convenience wrapper around the typed `db/history` accessor. The reader
 * calls this on a debounced trigger — after the user has lingered on a page
 * for 30s, or after they scroll past it. The IndexedDB write is fire-and-
 * forget; we don't want it to block UI threads.
 */
export interface RecordPageReadInput {
  sourceId: string;
  comicId: string;
  readUnitId?: string;
  readUnitTitle?: string;
  readGroupId?: string;
  readGroupTitle?: string;
  page: number;
  totalPages: number;
  titleSnapshot: string;
  coverUrl: string;
}

export async function recordPageRead(input: RecordPageReadInput): Promise<void> {
  try {
    await recordHistory({
      source: input.sourceId,
      comicId: input.comicId,
      readUnitId: input.readUnitId,
      readUnitTitle: input.readUnitTitle,
      readGroupId: input.readGroupId,
      readGroupTitle: input.readGroupTitle,
      lastPage: input.page,
      totalPages: input.totalPages,
      titleSnapshot: input.titleSnapshot,
      coverUrl: input.coverUrl,
    });
    requestAccountDataAutoSync();
  } catch (err) {
    // Don't surface IndexedDB failures to the reader — history is best-effort.
    console.warn('[history] recordPageRead failed', err);
  }
}
